/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

/*
 * Currency tools
 *
 * Copyright (c) 2013 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

if (typeof Currency === 'undefined') {
  var Currency = {};
}

Currency.cookie = {
  configuration: {
    expires: 365,
    path: '/',
    domain: window.location.hostname
  },
  name: 'currency',
  write: function(currency) {
    jQuery.cookie(this.name, currency, this.configuration);
  },
  read: function() {
    return jQuery.cookie(this.name);
  },
  destroy: function() {
    jQuery.cookie(this.name, null, this.configuration);
  }
};

Currency.money_with_currency_format = {
    "USD": "$ USD",
    "EUR": "&euro; EUR",
    "GBP": "&pound; GBP",
    "CAD": "$ CAD",
    "ARS": "$ ARS",
    "AUD": "$ AUD",
    "BBD": "$ Bds",
    "BDT": "Tk  BDT",
    "BSD": "BS$ BSD",
    "BHD": "0 BHD",
    "BRL": "R$  BRL",
    "BOB": "Bs BOB",
    "BND": "$ BND",
    "BGN": " Ð»Ð² BGN",
    "MMK": "K MMK",
    "KYD": "$ KYD",
    "CLP": "$ CLP",
    "CNY": "&#165; CNY",
    "COP": "$ COP",
    "CRC": "&#8353;  CRC",
    "HRK": " kn HRK",
    "CZK": " K&#269;",
    "DKK": "kr.",
    "DOP": "RD$ ",
    "XCD": "EC$",
    "EGP": "LE  EGP",
    "XPF": " XPF",
    "FJD": "FJ$",
    "GHS": "GH&#8373;",
    "GTQ": " GTQ",
    "GYD": "$ GYD",
    "GEL": " GEL",
    "HKD": "HK$",
    "HUF": " Ft",
    "ISK": " kr ISK",
    "INR": "Rs.",
    "IDR": "Rp ",
    "NIS": " NIS",
    "JMD": "$ JMD",
    "JPY": "&#165; JPY",
    "JOD": "0 JOD",
    "KZT": " KZT",
    "KES": "KSh",
    "KWD": "0 KWD",
    "LVL": "Ls  LVL",
    "LTL": " Lt",
    "MXN": "$  MXN",
    "MYR": "RM MYR",
    "MUR": "Rs  MUR",
    "MDL": " MDL",
    "MAD": "Dh  MAD",
    "MNT": " MNT",
    "MZN": "Mt  MZN",
    "ANG": " NA&fnof;",
    "NZD": "$ NZD",
    "NGN": "&#8358; NGN",
    "NOK": "kr  NOK",
    "OMR": " OMR",
    "PKR": "Rs. PKR",
    "PYG": "Gs.  PYG",
    "PEN": "S/.  PEN",
    "PHP": "&#8369; PHP",
    "PLN": " zl PLN",
    "QAR": "QAR ",
    "RON": " lei RON",
    "RUB": "&#1088;&#1091;&#1073; RUB",
    "SAR": " SAR",
    "RSD": " RSD",
    "SCR": "Rs  SCR",
    "SGD": "$ SGD",
    "SYP": "S&pound; SYP",
    "ZAR": "R  ZAR",
    "KRW": "&#8361; KRW",
    "LKR": "Rs  LKR",
    "SEK": " kr SEK",
    "CHF": "SFr.  CHF",
    "TWD": "$ TWD",
    "THB": " &#xe3f; THB",
    "TZS": " TZS",
    "TTD": "$ TTD",
    "TRY": "TL",
    "UAH": "â‚´ UAH",
    "AED": "Dhs.  AED",
    "UYU": "$ UYU",
    "VEB": "Bs.  VEB",
    "VND": " VND",
    "ZMK": "ZMK",
    "XBT": " BTC"
};

Currency.money_format = {
  "USD": "$",
  "EUR": "&euro;",
  "GBP": "&pound;",
  "CAD": "$",
  "ARS": "$",
  "AUD": "$",
  "BBD": "$",
  "BDT": "Tk ",
  "BSD": "BS$",
  "BHD": "0 BHD",
  "BRL": "R$ ",
  "BOB": "Bs",
  "BND": "$",
  "BGN": " Ð»Ð²",
  "MMK": "K",
  "KYD": "$",
  "CLP": "$",
  "CNY": "&#165;",
  "COP": "$",
  "CRC": "&#8353; ",
  "HRK": " kn",
  "CZK": " K&#269;",
  "DKK": "",
  "DOP": "RD$ ",
  "XCD": "$",
  "EGP": "LE ",
  "XPF": " XPF",
  "FJD": "$",
  "GHS": "GH&#8373;",
  "GTQ": "",
  "GYD": "$",
  "GEL": " GEL",
  "HKD": "$",
  "HUF": "",
  "ISK": " kr",
  "INR": "",
  "IDR": "",
  "NIS": " NIS",
  "JMD": "$",
  "JPY": "&#165;",
  "JOD": "0 JD",
  "KZT": " KZT",
  "KES": "KSh",
  "KWD": "0 KD",
  "LVL": "Ls ",
  "LTL": " Lt",
  "MXN": "$ ",
  "MYR": "RM MYR",
  "MUR": "Rs ",
  "MDL": " MDL",
  "MAD": " dh",
  "MNT": " &#8366",
  "MZN": " Mt",
  "ANG": "&fnof;",
  "NZD": "$",
  "NGN": "&#8358;",
  "NOK": "kr ",
  "OMR": " OMR",
  "PKR": "Rs.",
  "PYG": "Gs. ",
  "PEN": "S/. ",
  "PHP": "&#8369;",
  "PLN": " zl",
  "QAR": "QAR ",
  "RON": " lei",
  "RUB": "&#1088;&#1091;&#1073;",
  "SAR": " SR",
  "RSD": " RSD",
  "SCR": "Rs ",
  "SGD": "$",
  "SYP": "S&pound;",
  "ZAR": "R ",
  "KRW": "&#8361;",
  "LKR": "Rs ",
  "SEK": " kr",
  "CHF": "SFr. ",
  "TWD": "$",
  "THB": " &#xe3f;",
  "TZS": " TZS",
  "TTD": "$",
  "TRY": "TL",
  "UAH": "â‚´",
  "AED": "Dhs. ",
  "UYU": "$",
  "VEB": "Bs. ",
  "VND": "â‚«",
  "ZMK": "K",
  "XBT": " BTC"
};

Currency.formatMoney = function(cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.','');
  var value = '';
  var patt = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function addCommas(moneyString) {
    return moneyString.replace(/(\d+)(\d{3}[\.,]?)/,'$1,$2');
  }
  switch(formatString.match(patt)[1]) {
  case 'amount':
    value = addCommas(floatToString(cents/100.0, 2));
    break;
  case 'amount_no_decimals':
    value = addCommas(floatToString(cents/100.0, 0));
    break;
  case 'amount_with_comma_separator':
    value = floatToString(cents/100.0, 2).replace(/\./, ',');
    break;
  case 'amount_no_decimals_with_comma_separator':
    value = addCommas(floatToString(cents/100.0, 0)).replace(/\./, ',');
    break;
  }
  return formatString.replace(patt, value);
};

function floatToString(numeric, decimals) {
  var amount = numeric.toFixed(decimals).toString();
  if(amount.match(/^\.\d+/)) { return "0"+amount; }
  else { return amount; }
};

Currency.currentCurrency = '';
Currency.format = 'money_with_currency_format';

Currency.convertAll = function(oldCurrency, newCurrency, selector, format) {
  jQuery(selector || 'span.money').each(function() {
    // If the amount has already been converted, we leave it alone.
    if (jQuery(this).attr('data-currency') === newCurrency) return;
    // If we are converting to a currency that we have saved, we will use the saved amount.
    if (jQuery(this).attr('data-currency-'+newCurrency)) {
      jQuery(this).html(jQuery(this).attr('data-currency-'+newCurrency));
    }
    else {
      // Converting to Y for the first time? Let's get to it!
      var cents = 0.0;
      var oldFormat = Currency[format || Currency.format][oldCurrency] || '';
      var newFormat = Currency[format || Currency.format][newCurrency] || '';
      if (oldFormat.indexOf('amount_no_decimals') !== -1) {
        cents = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10)*100, oldCurrency, newCurrency);
      }
      else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
        cents = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10)/10, oldCurrency, newCurrency);
      }
      else {
        cents = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10), oldCurrency, newCurrency);
      }
      var newFormattedAmount = Currency.formatMoney(cents, newFormat);
      jQuery(this).html(newFormattedAmount);
      jQuery(this).attr('data-currency-'+newCurrency, newFormattedAmount);
    }
    // We record the new currency locally.
    jQuery(this).attr('data-currency', newCurrency);
  });
  this.currentCurrency = newCurrency;
  this.cookie.write(newCurrency);
};
